import { usePageTitle } from '@/hooks/usePageTitle';
import { createFileRoute } from '@tanstack/react-router'
import { ContinuousPaymentPortoutRequestForm } from '@/features/dashboard/continuous-payment-portout-request/form/ContinuousPaymentPortoutRequestForm';

export const Route = createFileRoute('/_dashboard/continuous-payment-portout-requests/new')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle("継続課金者転出依頼");
  return <ContinuousPaymentPortoutRequestForm />
}
